const ie11_mq1 = window.matchMedia('(-ms-high-contrast: active)')
const ie11_mq2 = window.matchMedia('(-ms-high-contrast: none)')

if (ie11_mq1.matches || ie11_mq2.matches) {
  var readyStateCheckInterval = setInterval(function () {
    if (document.readyState === 'complete') {
      clearInterval(readyStateCheckInterval)
      init()
    }
  }, 10)
}

function init() {
  const modal = document.getElementById('ie11-message')
  const overlay = document.querySelector('.PageOverlay')
  const html = document.documentElement

  if (modal && overlay && html) {
    overlay.classList.add('is-visible')
    modal.setAttribute('aria-hidden', 'false')
    html.classList.add('no-scroll')
    html.classList.add('is-ie11')

    const close = modal.querySelector('.Modal__Close')
    if (close) {
      close.addEventListener('click', function (event) {
        overlay.classList.remove('is-visible')
        modal.setAttribute('aria-hidden', 'true')
        html.classList.remove('no-scroll')
      })
    }
  }
}
